import 'typeface-roboto';

/* eslint-disable no-script-url */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AppContextProvider } from './store/app-context';

import { createTheme, ThemeProvider } from '@mui/material';

import Configuration from './configuration';
import { Table } from './containers/table/Table';

// Obtain environment variables and store then in local storage.
const env = process.env;
const deployment = env.REACT_APP_DEPLOYMENT;
localStorage.setItem('deployment', deployment ? deployment : 'missing from env file');
const cloudMessagingUrl = env.REACT_APP_CLOUD_MESSAGING_URL;
localStorage.setItem('cloudMessagingUrl', cloudMessagingUrl ? cloudMessagingUrl : 'missing from env file');
const cloudCoreURL = env.REACT_APP_FUNC_ONECONTROL_CORE_URL;
localStorage.setItem('cloudCoreUrl', cloudCoreURL ? cloudCoreURL : 'missing from env file');

const theme = createTheme();

ReactDOM.render(
  <Router>
    <Routes>
      <Route path="/" element={<ThemeProvider theme={theme}><Home /></ThemeProvider>} />
    </Routes>
  </Router>
  ,
  document.getElementById("root")
);

function Home() {
  const access_token = Configuration.getAccessToken();
  const canCreate = ("true" === localStorage.getItem('canCreate'));
  const canSend = ("true" === localStorage.getItem('canSend'));

  if (!!access_token) {
    if (!canCreate && !canSend) {
      Configuration.removeAccessToken();
      return <div>Unauthorized to use the Campaign Editor App.</div>
    } else {
      return <div>
        <AppContextProvider>
          <Table />
        </AppContextProvider>
      </div>;
    }
  } else {
    return <div>
      To use the Campaign Editor you must first authenticate with Salesforce.
    </div>
  }
}
